<groundworks-modal>
  <groundworks-modal-header
    [title]="title()"
    [isCancellable]="true"
    (cancelModal)="cancel()"
  />
  <groundworks-modal-body>
    <form [formGroup]="form">
      <div class="mb-3">
        <label class="form-label" for="removalReason">Reason for Removal <span class="text-danger">*</span></label>
        <ng-select
          id="removalReason"
          formControlName="reason"
          [items]="reasons()"
          placeholder="Please select a reason"
          [class.ng-select-invalid]="submitted() && form.get('reason')?.invalid"
        ></ng-select>
      </div>
    </form>
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
